import script from "./AgreeLicense.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgreeLicense.vue?vue&type=script&setup=true&lang=ts"

import "./AgreeLicense.vue?vue&type=style&index=0&id=5db0dfb1&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5db0dfb1"]])

export default __exports__